export const STATEMENTS_AND_DOCUMENTS_HEADER_NAMES = [
  "Date",
  "Title",
  "Type",
  "",
];

export const STATEMENTS_AND_DOCUMENTS_FIELD_TYPES = [
  "date",
  "title",
  "type",
  "actions",
];

export const STATEMENTS_NO_DATA_MESSAGE = "There are no statements to display";
export const TAX_DOCUMENTS_NO_DATA_MESSAGE =
  "There are no tax documents to display";
export const OTHER_DOCUMENTS_NO_DATA_MESSAGE =
  "There are no other documents to display";

export const EXTENSION_NOT_ALLOWED =
  "File extension not allowed. Please try again!";
export const UPLOAD_SUCCESS = "File uploaded successfully!";
export const UPLOAD_FAILED = "Upload document failed. Please try again!";
export const UPLOAD_NOT_ALLOWED = "You are not allowed to upload documents";
export const VIEW_DOCUMENT_NOT_ALLOWED_MESSAGE =
  "You are not allowed to view documents";
export const REQUEST_PAYOFF_NOT_ALLOWED_MESSAGE =
  "You are not allowed to request payoff quotes";
export const REQUEST_PAYOFF_SUCCESS =
  "Requested Payoff Quote successfully";
export const REQUEST_PAYOFF_FAILED =
  "Requested Payoff Quote failed. Please try again!";

export const UPLOAD_SIZE_EXCEEDED = (size) =>
  size < 1
    ? `The uploaded document should not exceed ${Math.round(size * 1000)}KB`
    : `The uploaded document should not exceed ${size}MB`;

export const UPLOAD_IMAGE_SIZE_EXCEEDED = (sizeKb) =>
  `The uploaded image should not exceed ${sizeKb}KB`;

export const UPLOAD_IMAGE_TYPE_NOT_ALLOWED = (extensions) =>
  `That image type is not supported. Allowed types: ${extensions.join(", ")}`;

export const DRAG_DROP_PLACEHOLDER =
  "Drag & Drop your file here or Click to browse file";

/** Top-level array key on document-types API response */
export const DOCUMENT_TYPES_API_LIST_KEY = "documentTypes";

/** Separates the category from the document in a document definition's name */
export const DOCUMENT_TYPE_DISPLAY_SEPARATOR = " ⇢ ";

export const DOCUMENT_VIEW_CATEGORY_STATEMENTS = "statements";
export const DOCUMENT_VIEW_CATEGORY_TAX = "tax";
export const DOCUMENT_VIEW_CATEGORY_OTHER = "other";

export const DOCUMENT_VIEW_CATEGORY_LABELS = {
  [DOCUMENT_VIEW_CATEGORY_STATEMENTS]: "STATEMENTS",
  [DOCUMENT_VIEW_CATEGORY_TAX]: "TAX DOCUMENTS",
  [DOCUMENT_VIEW_CATEGORY_OTHER]: "OTHER DOCUMENTS",
};

export const DOCUMENT_VIEW_SELECTION_CONFIG_PREFIX = {
  [DOCUMENT_VIEW_CATEGORY_STATEMENTS]: "STATEMENTS",
  [DOCUMENT_VIEW_CATEGORY_TAX]: "TAX",
  [DOCUMENT_VIEW_CATEGORY_OTHER]: "OTHER",
};

/**
 * The categories a borrower may upload. Each is one XDoc definition that the portal names for
 * the borrower rather than by the name XDoc holds it under, so "Tax" is the definition XDoc
 * calls "Tax Letter". Kept in step with the upload entries of the Documents enum in the
 * document service, which is where the two names and the schemaId are held together.
 */
export const DOCUMENT_UPLOAD_TYPES = [
  { schemaId: "200110101", label: "Tax" },
  { schemaId: "200110098", label: "Insurance" },
  { schemaId: "200110018", label: "Correspondence" },
  { schemaId: "200110150", label: "ACH Authorization" },
  { schemaId: "200110052", label: "Legal Documents" },
  { schemaId: "200110022", label: "Mortgage Assistance" },
  { schemaId: "200110126", label: "Insurance Claim" },
];

export const DOCUMENT_DOWNLOAD_TYPES = [
  "Statements",
  "BK Statements",
  "HELOC Statement",
  "HELOC BK Statement",
  "Short Year Statement",
  "Escrow Analysis",
  "PMI Notice",
  "MIP Notice",
  "1098",
  "1099A",
  "1099C",
  "1099Int",
  "1099Misc",
  "1099Nec",
  "Breach Letter",
  "ARM Rate/Payment Letter",
  "Late Notice",
  "Transfer Of Servicing Letter",
  "Welcome Letter",
  "Forbearance Agreement",
  "Loan Modification Agreement",
];

export const PAYOFF_REQUEST_REASONS = [
  "Refinance with current lender",
  "Refinance with another lender",
  "Sale of home",
  "Final payment",
];

export const NO_CONTENT_STATUS = 204;
export const NO_EMAIL_SET = "No Email Set";
